import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractSpecificationVisitor from "../../specification/visitors/AbstractSpecificationVisitor.js";

/**
 * `LabelsDimensionSpecificationVisitor` returns the labels
 * of each dimension in a dimension specification.
 *
 * @param {dimension} spec.dimensionTree - Dimension tree where dimension names are fetched
 */
export default class LabelsDimensionSpecificationVisitor extends AbstractSpecificationVisitor {
	constructor({ dimensionTree }) {
		super(...arguments);
		this._dimensionTree = dimensionTree;
	}

	visitDimensionSpecification(aSpecification) {
		const dimension = this._dimensionTree.findById(
			aSpecification.getDimensionId(),
		);
		const label = dimension
			? dimension.getLabel()
			: _("{id} (missing)", { id: aSpecification.getDimensionId() });
		return [label];
	}

	visitCompositeSpecification(aSpecification) {
		return aSpecification.getSpecifications().reduce((acc, spec) => {
			acc.push(...spec.accept(this));
			return acc;
		}, []);
	}

	visitNotSpecification(aSpecification) {
		return aSpecification
			.getSpecification()
			.accept(this)
			.map((label) => _("excluding {label}", { label }));
	}
}
